import React from "react";
import { ok } from "neverthrow";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { eqeqeq } from "../../../../../../shared/utils/equality";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import GenericTextFormItemProvider from "../../_generic/text/GenericTextFormItemProvider";
import identity from "../../../../../../shared/utils/identity";

const fieldName = "Vessel Name";

const VesselNameFormItemProvider: FormItemProvider<string> = (props: FormItemProviderProps<string>) => (
  <GenericTextFormItemProvider
    {...props}
    fieldType="VesselName"
    fieldName={fieldName}
    inputToResult={notEmptyInputToResultWrapper(fieldName, ok)}
    outputToInput={identity}
    suggestPrevious={true}
    outputToSuggestionText={identity}
    autoFillPrevious={true}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(VesselNameFormItemProvider);